<template>
  <section>
    <el-col :span="24" class="toolbar">
      <el-form label-width="100px" :inline="true" :model="filters">
        <el-form-item label="UID">
          <el-input v-model="filters.user_id" placeholder="user_id"></el-input>
        </el-form-item>
        <el-form-item label="Tên Game">
          <el-select v-model="filters.merchant_id" placeholder="Tên Game">
            <el-option
              v-for="item in game_list"
              :key="item.merchant_id"
              :label="item.username"
              :value="item.merchant_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <div style="margin-left: 100px">
          <el-form-item>
            <el-button type="primary" @click="searchUsers()">Tìm</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reset()">Đặt Lại</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-col>
    <el-col :span="24">
      <el-table
        id="mainTable"
        :data="user_info"
        highlight-current-row
        v-loading="listLoading"
        empty-text="Không có dữ liệu"
        style="width: 100%"
      >
        <el-table-column prop="user_id" label="user ID"> </el-table-column>
        <el-table-column prop="name" label="name"> </el-table-column>
        <el-table-column prop="gender" label="gender"> </el-table-column>
        <el-table-column prop="username" label="Tài Khoản"> </el-table-column>
        <el-table-column prop="mobile" label="phone"> </el-table-column>
        <el-table-column prop="merchant_id" label="Tên Game"> </el-table-column>
        <el-table-column prop="birth" label="birthDay"> </el-table-column>
        <el-table-column prop="created_at" label="Thời gian tạo">
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-col :span="24" class="toolbar footer_pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="Number(currentPage)"
          @current-change="handleCurrentChange"
        />
      </el-col>
    </el-col>
  </section>
</template>

<script>
import { gameListApi, userListApi } from "@/utils/api";
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      filters: {
        user_id: "",
        merchant_id: "",
      },
      token: localStorage.getItem("token"),
      userInfo: {},
      date: null,
      user_info: [],
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pageSize: 20, // 分页大小
      listLoading: false,
      game_list: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getGameList();
  },
  mounted() {},
  methods: {
    //获取用户列表
    getUsers() {
      let params = {
        token: this.token,
        page: this.currentPage,
        ...this.filters,
      };
      this.listLoading = true;
      userListApi(params).then((res) => {
        if (res.code == 200) {
          this.total = res.total;
          this.currentPage = res.page;
          this.user_info = res.data;
          this.user_info.forEach((item) => {
            item.gender = item.gender == 1 ? "male" : "female";
          });
        } else {
          this.total = 0;
          this.currentPage = 1;
          this.user_info = [];
          this.$message.error(res.msg);
        }
        this.listLoading = false;
      });
    },

    //获取游戏列表
    getGameList() {
      gameListApi().then((res) => {
        if (res.code == 200) {
          this.game_list = res.data;
          this.getUsers();
        }
      });
    },

    searchUsers() {
      this.currentPage = 1;
      this.getUsers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUsers();
    },

    reset() {
      this.filters = {
        user_id: "",
        merchant_id: "",
      };
      this.handleCurrentChange(1);
    },
  },
};
</script>

<style scoped>
/* 用户信息详情 */
.user-info {
  margin-bottom: 30px;
  padding-top: 20px;
}

.info-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  width: 100px;
  color: #666;
  font-weight: 500;
}

.info-value {
  flex: 1;
  color: #333;
}

.footer_pagination {
  margin: 20px 0;
  text-align: right;
}
</style>
